import React from 'react';
import { Box } from '@mui/material';

interface ErrorMessageBoxProps {
    message: string;
}

export default function ErrorMessageBox({ message }: ErrorMessageBoxProps) {
    if (!message) return null;
    
    return (
        <Box
            sx={{
                position: 'absolute',
                top: '10px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 2000,
                backgroundColor: 'error.main',
                color: 'error.contrastText',
                padding: '10px 20px',
                borderRadius: '4px',
                boxShadow: 3,
            }}
        >
            {message}
        </Box>
    );
} 